import { ReactNode } from 'react';
import { toast } from 'react-toastify';

import { ApiError } from '@arrived/models';

export const notificationService = {
  success: (message: ReactNode) => {
    return toast.success(message, {
      className: 'notification-success-body',
    });
  },

  // client side errors
  errors: (errors: ReactNode[]) => {
    errors.forEach((error) => {
      return toast.error(error, {
        className: 'notification-error-body',
      });
    });
  },

  // api response error
  error: (error: ApiError | ReactNode) => {
    if (error === null) {
      return null;
    }

    const text = typeof error === 'object' && 'description' in error ? error.description : (error as ReactNode);

    return toast.error(text, {
      className: 'notification-error-body',
    });
  },
};
